import React from "react";
import { useTranslation } from "react-i18next";
import underlineimage from "../assets/images/title-shape.png";
import frnbbg from "../assets/images/Esportsec/esportsrewards.png";
import friendinvite from "../assets/images/Esportsec/EsportsRoundImgs/rewardround.png";
const Rewards: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div
      className="relative bg-[#070b28] bg-no-repeat bg-contain bg-bottom overflow-hidden pt-16 pb-24 px-4 md:px-8"
      style={{ backgroundImage: `url(${frnbbg})` }}
    >
      {/* Header Section */}
      <div className="relative z-10 text-center mb-12">
        <h2 className="text-[32px] md:text-[48px] font-oswald font-extrabold text-white leading-tight">
          Rewards
        </h2>
        <img src={underlineimage} alt="underline" className="mx-auto mt-2 w-[100px] h-auto" />
        <p className="text-[18px] md:text-[20px] font-oswald font-medium max-w-2xl mx-auto text-white leading-7 mt-4">
          We have exciting rewards from shopping vouchers, wallet top-ups & in-game currencies
        </p>
      </div>

      {/* Content Section */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-10 md:gap-20 max-w-6xl mx-auto">
        {/* Left: Image */}
       

        {/* Right: Text */}
        <div className="w-full md:w-1/2 text-center md:text-left px-2 md:px-0">
          <p className="text-[18px] md:text-[22px] font-oswald font-semibold text-[#ffffff] max-w-xl mx-auto md:mx-0">
          {t("watch.description")}
          </p>
        </div>
         <div className="w-full md:w-1/2 flex justify-center px-2 md:px-0">
          <img
            src={friendinvite}
            alt={t("services.inviteImageAlt")}
            className="w-full max-w-[350px] md:max-w-[400px] h-auto"
          />
        </div>
      </div>
      </div>
  
  );
};

export default Rewards;
